<template>
  <!-- EP签证信息 - 表单面板(弹窗编辑/回显平铺 复用) -->
  <el-form
    ref="formRef"
    :model="form"
    :rules="rules"
    label-position="top"
    :disabled="isReadonly"
    :class="{ readOnlyStyle: isReadonly }"
    class="dataForm"
  >
    <el-row :gutter="20" class="pt22">
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.cardName')" prop="fullName" ref="fullName">
          <el-input v-model="form.fullName" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.nationality')" prop="nationality" ref="nationality">
          <el-select v-model="form.nationality" :placeholder="$t('common.placeholder.select')" filterable class="wdb100">
            <el-option v-for="item of globalFormatList('nationalityList')" :key="`nationality-${item.value}`" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.cardType')" prop="identificationType" ref="identificationType">
          <el-select v-model="form.identificationType" :placeholder="$t('common.placeholder.select')" class="wdb100">
            <el-option v-for="item of byCountryFormatList('identificationData')" :key="`cardType-${item.value}`" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.cardNo')" prop="identificationNo" ref="identificationNo">
          <el-input v-model="form.identificationNo" :placeholder="$t('common.placeholder.enter')" v-regexFilter="$halfWidthRegex" class="wdb100"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.phone')" prop="phone" ref="phone">
          <prefix-phone v-model="form.phone" class="wdb100"></prefix-phone>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.email')" prop="email" ref="email">
          <el-input v-model="form.email" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.address')" prop="residentialAddress" ref="residentialAddress">
          <el-input v-model="form.residentialAddress" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.birthDate')" prop="birthDate" ref="birthDate">
          <el-date-picker v-model="form.birthDate" type="date" :placeholder="$t('common.placeholder.select')" value-format="yyyy-MM-dd" class="wdb100"></el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <!-- 是否在中国大陆公司持有股份 -->
      <el-col :span="12">
        <el-form-item :label="$t('enroll.intitle.isHasPrcInland')" prop="isHoldShareOfPrcInland" ref="isHoldShareOfPrcInland">
          <el-select v-model="form.isHoldShareOfPrcInland" :placeholder="$t('common.placeholder.select')" @change="isHoldShareOfPrcInlandChange" class="wdb100">
            <el-option :value="1" :label="$t('common.yes')"></el-option>
            <el-option :value="0" :label="$t('common.no')"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <!-- 持有股份的中国公司名称(请提供1家) -->
      <el-col :span="12" v-if="form.isHoldShareOfPrcInland">
        <el-form-item :label="$t('enroll.intitle.prcInlandName')" prop="holdShareOfPrcEntity" ref="holdShareOfPrcEntity">
          <el-input v-model="form.holdShareOfPrcEntity" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import validatorMixin from "@/mixins/validatorMixin";
import { validateFormLocation } from "@/utils/common";
import { mapGetters } from "vuex";

export default {
  name: "EpVisaFormPanel",
  mixins: [validatorMixin],
  props: {
    /** 表单数据对象(弹窗模式: dataForm; 回显模式: EP申请人row) */
    form: { type: Object, required: true },
    isReadonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters("constant", ["globalFormatList", "byCountryFormatList"]),
    rules() {
      return {
        fullName: [{ required: true, message: this.$t("common.placeholder.enter"), trigger: "submit" }],
        nationality: [{ required: true, message: this.$t("common.placeholder.select"), trigger: "submit" }],
        identificationType: [{ required: true, message: this.$t("common.placeholder.select"), trigger: "submit" }],
        identificationNo: [{ required: true, message: this.$t("common.placeholder.enter"), trigger: "submit" }],
        email: [
          { required: true, message: this.$t("common.placeholder.enter"), trigger: "submit" },
          { type: "email", message: this.$t("common.regular.email"), trigger: "submit" },
        ],
        phone: [{ required: true, validator: this.validatePhone, trigger: "submit" }],
        residentialAddress: [{ required: true, message: this.$t("common.placeholder.enter"), trigger: "submit" }],
        birthDate: [{ required: true, validator: this.validateBirthday, trigger: "submit" }],
        isHoldShareOfPrcInland: [{ required: true, message: this.$t("common.placeholder.select"), trigger: "submit" }],
        holdShareOfPrcEntity: [{ required: true, message: this.$t("common.placeholder.enter"), trigger: "submit" }],
      };
    },
  },
  methods: {
    /** 清除校验状态(供父组件通过ref调用) */
    clearValidate() {
      this.$nextTick(() => {
        if (this.$refs.formRef) this.$refs.formRef.clearValidate();
      });
    },
    /** 供父组件触发表单校验 */
    validate(callback) {
      this.$refs.formRef.validate((valid, object) => {
        if (!valid) validateFormLocation(object, this.$refs.formRef);
        callback && callback(valid);
      });
    },
    // 是否在中国大陆公司持有股份 - change
    isHoldShareOfPrcInlandChange() {
      if (this.form.isHoldShareOfPrcInland == 0) {
        this.$set(this.form, "holdShareOfPrcEntity", null);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* 表单项基础样式(与弹窗内展示保持一致) */
.dataForm ::v-deep {
  .el-form-item__label {
    line-height: 1em;
    padding: 0 0 8px;
  }
  .el-form-item {
    margin-bottom: 20px;
  }
}
</style>
